/**
 * Where the product's own documentation lives, by section.
 *
 * The app is `app.augrank.com` and the docs are on the marketing site at
 * `augrank.com/docs/*`, a different origin — so these are absolute URLs and the
 * links that use them open a new tab, because a tenant halfway through a
 * connection should not lose the screen they are on to read how to finish it.
 *
 * The anchors are the marketing page's heading ids, and
 * `marketing/tests/parity.test.ts` asserts each one still exists there: a
 * renamed heading is a link that lands at the top of the page and says nothing.
 */
const DOCS = 'https://augrank.com/docs'

export const GOOGLE_DOCS = {
  /** Which Google account to sign in with, and why it matters before pressing Connect. */
  beforeYouStart: `${DOCS}/connecting-google/#before-you-start`,
  /** The three routes out of "we connected, but found no matching property". */
  noMatchingProperty: `${DOCS}/connecting-google/#no-matching-property`,
  /** Verifying a domain in Search Console with a DNS TXT record. */
  verifyYourSite: `${DOCS}/connecting-google/#verify-your-site`,
  /** Choosing the GA4 property, and the two things that stop it. */
  analytics: `${DOCS}/connecting-google/#analytics`,
  /** Why a working connection is still empty for the first days. */
  whyIsItEmpty: `${DOCS}/connecting-google/#why-is-it-empty`,
} as const
